export default function getStorage(name){
    var value = null;
    if (window.localStorage) {
        value = localStorage.removeItem(name);
       
    }else{
        value = localStorage.removeItem(name);
    }
    try{
        value = JSON.parse(value)
        return value;
    }catch(e){
        return value
    }
}